var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { FunctionColor } from '@lux/core';
export var RRPRegularText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .discount {\n        font-weight: bold;\n        color: ", ";\n    }\n\n    .br {\n        display: block;\n    }\n"], ["\n    .discount {\n        font-weight: bold;\n        color: ", ";\n    }\n\n    .br {\n        display: block;\n    }\n"])), FunctionColor.function100);
var templateObject_1;
